import {Input, Label} from "@ui5/webcomponents-react";
import {useEffect, useState} from "react";

interface MailAddressProps {
    onMailAddressChange: (mailAddress: string) => void;
    onMailAddressStateChange: (state: 'Negative' | 'None') => void;
}

const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function validateEmail(email: string): boolean {
    return emailRegex.test(email);
}

export function MailAddress(props: MailAddressProps) {
    const [value, setValue] = useState('marcel.minke@survey-consulting.com');
    const [valueState, setValueState] = useState<'Negative' | 'None'>('None')

    useEffect(() => {
        if (!validateEmail(value)) {
            setValueState('Negative');
            props.onMailAddressStateChange?.('Negative');
            return;
        }
        setValueState('None');
        props.onMailAddressStateChange?.('None');
        props.onMailAddressChange(value);
    }, [value])
    return <div className={"sc_filter"}>
        <Label className="sc_label">Mail Address</Label>
        <Input
            className="sc_input"
            key={'mailAddress'}
            onInput={ev => setValue(ev.target.value)}
            placeholder="Enter your email address"
            type="Email"
            valueState={valueState}
            value={value}
        />
    </div>
}